import { createActionGroup, props } from '@ngrx/store';

import { OperatorActivityLog, SurveyActivityLog } from '@ps/survey-utils';

export const SurveyActivityLogActions = createActionGroup({
  source: 'Survey Activity Log',
  events: {
    'Log Activity': props<{ log: SurveyActivityLog }>(),
    'Log Operator Activity': props<{ log: OperatorActivityLog }>(),
  },
});
